import NewsTemplate from '../../sections/news-list/templates/news-list.twig';
import Observer from '../../common/scripts/observer';
import {Utils} from '../../common/scripts/utils';

const observer = new Observer();
const lastArrayIndex = -1;

class ShowMore {
    constructor(options) {
        this.template = '';
        this.loadMore = options.button;
        this.list = options.listWrapper;
        this.itemClass = options.itemClass;
        this.nodesAfterLastItem = options.nodesAfterLastItem;
        this.baseText = this.loadMore.textContent;
        this.loadingText = options.loadingText || `Загрузка`;
        this.url = options.url;
        this.yearsList = options.yearsList || false;
        this.yearsItem = options.yearsItem;
        this.searchField = options.searchField || false;
    }

    /**
     * Инициализация экземпляра класса
     * @public
     */
    init() {
        this._bindEvents();
    }

    /**
     * Бинд событий
     * @private
     */
    _bindEvents() {
        this.loadMore.addEventListener('click', () => {
            const data = this._collectData();

            this._loadReports(data);
        });
    }

    /**
     * Собираем данные для отправки запроса
     * @returns {object} data - объект с данными для отправки
     */
    _collectData() {
        const data = {
            count: this.list.childElementCount - this.nodesAfterLastItem
        };

        if (this.list.dataset.content) {
            data['loadMore'] = this.list.dataset.content;
        }

        // Проверяем есть ли теги. Получаем список активных тегов
        const tagsList = document.querySelector('.j-news-list-tags');
        let tagsData = [];

        if (tagsList) {
            tagsData = this._getTags(tagsList);
        }

        data['tags'] = tagsData;

        // Проверяем есть ли года
        let yearActive = '';

        if (this.yearsList) {
            yearActive = this.yearsList.querySelector(`${this.yearsItem}.is-active`).dataset.year;
        }

        data['year'] = yearActive;

        // Проверяем есть ли страницы
        if (this.loadMore.dataset.page) {
            data['page'] = this.loadMore.dataset.page;

            this.loadMore.dataset.page = Number(this.loadMore.dataset.page) + 1;
        }

        // Проверяем есть ли поисковая строка и передаем ее текст
        if (this.searchField) {
            data['search'] = this.searchField.value;
        }

        return data;
    }

    /**
     * Полкучаем активный тег
     * @param {object} tagsList - список тегов
     * @returns {array} - массив тегов
     */
    _getTags(tagsList) {
        const tags = Array.from(tagsList.querySelectorAll('.j-news-tag'));
        const tagsData = [];

        const filteredTags = tags.filter((tag) => {
            return tag.classList.contains('is-active');
        });


        if (filteredTags.length) {
            filteredTags.forEach((item) => {
                tagsData.push(item.dataset.tag);
            });
        }

        return tagsData;
    }

    /**
     * Подгружает новые альбомы хода строительства
     * @param {object} sendData - отправляемые данные
     * @private
     */
    _loadReports(sendData = {}) {
        const formData = this._convertObjectToFormData(sendData);
        const that = this;

        that._disableMore();
        that._addLoadingState();

        this._checkTemplate();

        Utils.send(formData, that.url, {
            success(response) {
                const {data} = response;

                that._checkLastPage(data.more);
                that._insertItems(data);

                if (that.url.match('news') || that.url.match('all') || that.url.match('actions')) {
                    observer.publish('loadProgress', that.list, data.items.length);
                }

                observer.publish('popup:refresh');
            },
            error(error) {
                console.error(error);
            },
            complete() {
                that._enableMore();
                that._removeLoadingState();
            }
        }, 'POST');
    }

    /**
     * Конвертирует объект в экземпляр класса FormData
     * @param {object} data - данные для конвертации
     * @return {object} - объект FormData
     * @private
     */
    _convertObjectToFormData(data) {
        const formData = new FormData();

        Object.keys(data).forEach((key) => {
            formData.append(key, data[key]);
        });

        return formData;
    }

    _checkTemplate() {
        const that = this;

        if (that.url.match('news')) {
            this.template = NewsTemplate;
        }
    }

    /**
     * Вставляет новые элементы в контейнер
     * @param {object} data - данные для заполнения шаблона
     * @private
     */
    _insertItems(data) {
        this._checkTemplate(data);
        const lastItem = [].slice.call(this.list.querySelectorAll(this.itemClass)).splice(lastArrayIndex)[0];

        lastItem.insertAdjacentHTML('afterend', this.template(data));
    }

    /**
     * Если полседняя стр. то убирает кнопку load more
     * @param {boolean} state - последняя ли стр.
     * @private
     */
    _checkLastPage(state) {
        this.loadMore.style.display = state ? 'block' : 'none';
    }

    /**
     * Деакцтивирует кнопку подгрузки
     * @private
     */
    _disableMore() {
        this.loadMore.classList.add('is-disabled');
    }

    /**
     * Активирует кнопку подгрузки
     * @private
     */
    _enableMore() {
        this.loadMore.classList.remove('is-disabled');
    }

    /**
     * Добавляет класс анимации загрузки
     * @private
     */
    _addLoadingState() {
        this.loadMore.classList.add('is-loading');

        if (this.loadMore.querySelector('.button__text')) {
            this.loadMore.querySelector('.button__text').textContent = this.loadingText;
        } else {
            this.loadMore.textContent = this.loadingText;
        }
    }

    /**
     * Удаляет класс анимации загрузки
     * @private
     */
    _removeLoadingState() {
        this.loadMore.classList.remove('is-loading');

        if (this.loadMore.querySelector('.button__text')) {
            this.loadMore.querySelector('.button__text').textContent = this.baseText;
        } else {
            this.loadMore.textContent = this.baseText;
        }
    }
}

export default ShowMore;

